import {LOGIN_USER} from "../actions/login";
const initialState = {
    login_waiting : false,
    login_success : {},
    login_error :{},
}

export default function login(state = initialState, action){
    switch (action.type){
        case LOGIN_USER:
            return {
                ...state,
                login_waiting : action.login_waiting,
                login_success : action.login_response,
                login_error : action.login_error
            }
        default:
            return state;
    }
}
